"use client";

import { getBrandProducts, getBrands } from "@/features/brands/services/brands.service";

export interface BrandProduct {
  id: string;
  slug: string;
  title: string;
  primary_image: string;
  price: number;
  compare_at_price: number;
  discount_percentage: string;
  rating: number;
  review_count: number;
  in_stock: boolean;
  brand_name: string;
}

export interface BrandSummary {
  id: string;
  name: string;
  slug: string;
  logo_url: string | null;
  product_count: number;
  avg_rating: string;
  total_reviews: number;
}

type BrandProductsMeta = { total?: number };

export async function getBrandBySlug(slug: string) {
  const brands = await getBrands<BrandSummary>();
  return brands.find((brand) => brand.slug === slug) ?? null;
}

export async function getBrandProductsPage(slug: string, page: number, limit: number) {
  return getBrandProducts<BrandProduct, BrandProductsMeta>(slug, page, limit);
}
